import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './hoc/Layout/Layout';
import { connect } from 'react-redux';
import Footer from './Navigation/Footer/Footer';
import './App.css';
import { setAdmin } from './store/actions/auth';
import { auth } from './firebase/index';
import axios from './axiosdata';

import Mainpage from './Containers/Mainpage/MainpageContainer';
import Contact from './Containers/Contact/ContactContainer';
import Juontaminen from './Containers/Content/Juontaminen';
import Info from './Containers/Content/Info';
import Admin from './Containers/Auth/Auth';
import Logout from './Containers/Auth/Logout/Logout';

class App extends Component {

  componentDidMount() {
    this.authUnsubscribe = auth.onAuthStateChanged(async user => {
      if (user) {
        try {
          const res = await axios.get('/admin_users.json');
          if (res.data && res.data[user.uid]) {
            this.props.onSetAdmin(true);
          } else {
            this.props.onSetAdmin(false);
          }
        } catch (err) {
          console.error('[Auth] admin check failed:', err);
          this.props.onSetAdmin(false);
        }
      } else {
        this.props.onSetAdmin(false);
      }
    });
  }

  componentWillUnmount() {
    if (this.authUnsubscribe) {
      this.authUnsubscribe();
    }
  }

  render() {
    return (
      <div className="App">
        <div className="page_wrapper">
          <Layout>
            <Routes>
              <Route path="/admin" element={<Admin />} />
              <Route path="/podcast" element={<Info />} />
              <Route path="/juontaminen" element={<Juontaminen />} />
              <Route path="/yhteystiedot" element={<Contact />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/" element={<Mainpage />} />
            </Routes>
          </Layout>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  onSetAdmin: (isAdmin) => dispatch(setAdmin(isAdmin))
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
